var path = '/app/components/dialogs/trophies/trophies.html';
var html = "<div class=intervencional-modal-wrap style=\"background-image:url('{{ $ctrl.bg }}')\"> <div class=modal-body> <div class=parts> <img ng-src={{$ctrl.renderPuzzlePart(p)}} ng-repeat=\"p in $ctrl.collecteds\" class=part> </div> <p class=parts-text> Você ganhou <b>{{ $ctrl.totalCollectedI18n }}</b> {{ $ctrl.collecteds > 1 ? 'peças' : 'peça' }} do quebra cabeça! </p> <a class=btn-confirm ng-click=$ctrl.ok()></a> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/trophies/trophies.html
// module id = 214
// module chunks = 0